import React, { useState, useEffect } from 'react'
import Loader from '../../Components/Advanced/Loader/Loader'
//
import { useLocation } from 'react-router-dom'
import getPageTitle from '../../Components/Advanced/Router/Utility'
// Styles
import HeroSection from './Components/HeroSection/HeroSection'
import CryptoSliders from './Components/CryptoSliders/CryptoSliders'
import InnovativeProduct from './Components/InnovativeProduct/InnovativeProduct'
import EnterEmailSection from '../../Components/UIKit/EnterEmailSection/EnterEmailSection'
import ReliabilitySection from './Components/ReliabilitySection/ReliabilitySection'

const HomePageView = () => {
  const [loading, setLoading] = useState(true)
  const { pathname } = useLocation()

  if (loading) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'unset'
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = getPageTitle(pathname)
    setTimeout(() => {
      setLoading(false)
    }, 2100)
  }, [])
  return (
    <>
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      <HeroSection />
      <CryptoSliders />
      <InnovativeProduct />
      <ReliabilitySection />
      {/* <EnterEmailSection /> */}
    </>
  )
}

export default HomePageView
